import {
    Event as EventIcon,
    Home as HomeIcon
} from "@material-ui/icons";
import React from "react";

type Item = {
    href: string;
    render?: React.ReactNode;
    icon?: React.ElementType;
    isVisible: (currentTicketOffice?: any) => boolean;
};

export const items: Array<Item> = [
    {
        href: "/home",
        icon: HomeIcon,
        isVisible: () => true,
    },
    {
        href: "/agendamento",
        icon: EventIcon,
        isVisible: (currentTicketOffice) => {
            return (
                currentTicketOffice &&
                currentTicketOffice.tipo === "Presencial"
            );
        }
    },
    {
        href: "/atendimento",
        icon: EventIcon,
        isVisible: (currentTicketOffice) => {
            return (
                currentTicketOffice &&
                currentTicketOffice.tipo === "Online"
            );
        }
    },
    {
        href: "/consulta_agendamento",
        icon: EventIcon,
        isVisible: (currentTicketOffice) => {
            return (
                currentTicketOffice &&
                currentTicketOffice.tipo === "Consulta"
            );
        }
    },
    {
        href: "/atendimento_diario",
        icon: EventIcon,
        isVisible: (currentTicketOffice) => {
            return (
                currentTicketOffice &&
                currentTicketOffice.tipo === "Diario"
            );
        }
    }
];